import React from "react";
import { StatusBar, BottomNav, ScreenHeader } from "../components/Shell";
import Ico from "../components/Ico";
import { useAppStore } from "../components/AppStore";
import { transactions, goals, currentUser } from "../mock";
import { TrendingUp, PiggyBank, ArrowDownLeft, PlusCircle } from "lucide-react";

export default function Earnings() {
  const { savedTotal, addToSavings } = useAppStore();
  return (
    <div className="gd-screen bg-[#eef1fb]">
      <div className="flex-shrink-0">
        <div className="gd-header-grad px-5 pb-20" style={{ borderBottomLeftRadius: 30, borderBottomRightRadius: 30 }}>
          <StatusBar dark={false} />
          <h1 className="mt-1 text-2xl font-extrabold text-white">Piggy Bank</h1>
          <p className="text-sm text-white/70">Track every dollar you earn</p>
        </div>
      </div>

      <div className="gd-scroll -mt-14 px-4 pb-6 gd-stagger">
        {/* balance */}
        <div className="overflow-hidden rounded-[24px] p-5 text-white" style={{ background: "linear-gradient(135deg,#f5a63a,#e97f0c)" }}>
          <p className="text-xs font-semibold text-white/80">Total Balance</p>
          <p className="mt-1 text-4xl font-black">${currentUser.earned}</p>
          <div className="mt-4 flex gap-3">
            <div className="flex-1 rounded-2xl bg-white/15 p-3"><p className="text-[11px] text-white/75">This Week</p><p className="text-lg font-extrabold">${currentUser.weeklyEarned}</p></div>
            <div className="flex-1 rounded-2xl bg-white/15 p-3"><p className="text-[11px] text-white/75">Saved</p><p className="text-lg font-extrabold">${savedTotal}</p></div>
          </div>
        </div>

        {/* goals */}
        <div className="mb-2 mt-5 flex items-center justify-between">
          <h3 className="text-base font-extrabold text-[#1f2a52]">Savings Goals</h3>
        </div>
        <div className="space-y-3">
          {goals.map((g) => {
            const saved = g.name === "New Bicycle" ? savedTotal : g.saved;
            const pct = Math.min(100, Math.round((saved / g.target) * 100));
            return (
              <div key={g.name} className="gd-card p-4">
                <div className="flex items-center justify-between">
                  <span className="text-sm font-extrabold text-[#1f2a52]">{g.name}</span>
                  <span className="text-sm font-bold" style={{ color: g.tint }}>${saved} / ${g.target}</span>
                </div>
                <div className="mt-2 h-2.5 rounded-full bg-[#eef1fb]"><div className="h-2.5 rounded-full" style={{ width: `${pct}%`, background: g.tint }} /></div>
                <p className="mt-1 text-[11px] font-semibold text-[#9aa3c0]">{pct}% there · {pct >= 100 ? "Goal reached!" : `$${g.target - saved} to go`}</p>
              </div>
            );
          })}
        </div>

        <button onClick={() => addToSavings(10)} className="gd-orange-btn mt-3 flex w-full items-center justify-center gap-2 rounded-2xl py-3.5 font-extrabold">
          <PlusCircle size={18} /> Move $10 to Bicycle Goal
        </button>

        {/* transactions */}
        <h3 className="mb-2 mt-5 text-base font-extrabold text-[#1f2a52]">Recent Activity</h3>
        <div className="gd-card divide-y divide-[#f0f2fa] p-1">
          {transactions.map((t) => (
            <div key={t.id} className="flex items-center gap-3 px-3 py-3">
              <div className="grid h-11 w-11 place-items-center rounded-2xl" style={{ background: t.type === "save" ? "#efe9fb" : "#eaf6ea" }}>
                <Ico name={t.icon} size={20} color={t.type === "save" ? "#8b5cf6" : "#4fae3f"} />
              </div>
              <div className="flex-1"><p className="text-sm font-bold text-[#1f2a52]">{t.title}</p><p className="text-[11px] font-semibold text-[#9aa3c0]">{t.date}</p></div>
              <div className="flex items-center gap-1 text-sm font-black" style={{ color: t.type === "save" ? "#8b5cf6" : "#4fae3f" }}>
                {t.type === "save" ? <PiggyBank size={14} /> : <ArrowDownLeft size={14} />}
                {t.type === "save" ? "-" : "+"}${t.amount}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-4 flex items-center gap-2 rounded-2xl bg-[#efe9fb] p-3 text-[12px] font-semibold text-[#7c4fd0]">
          <TrendingUp size={16} /> You're 70% toward your Bicycle goal — keep hustling!
        </div>
      </div>

      <BottomNav />
    </div>
  );
}
